import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectSelectedChannel } from '../../../../store/app.selectors';
import { IMessageableEntity } from '../../interfaces/IMessageableEntity';
import { ChannelsService } from '../../services/channels.service';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-owner-change',
  templateUrl: './owner-change.component.html',
  styleUrls: ['./owner-change.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OwnerChangeComponent {
  private channelsService = inject(ChannelsService);
  private store = inject(Store<AppStateWithChat>);

  @Output() closeDrop = new EventEmitter<boolean>();

  usersSelected: IMessageableEntity[] = [];
  selectedChannel = toSignal(this.store.select(selectSelectedChannel), { initialValue: null });

  changeOwner(user: IMessageableEntity | undefined): void {
    const channel = this.selectedChannel();
    if (user && channel) {
      this.channelsService.changeChannelOwner(channel, user.businessReference!.entityUID, user.displayName, true);
      this.closeDrop.emit(true);
    }
  }
}
